__turbopack_context__.v({
  "buttons": "_4w2Gda_buttons",
  "logo": "_4w2Gda_logo",
  "navigation": "_4w2Gda_navigation",
  "navigation--hidden": "_4w2Gda_navigation--hidden",
  "navigation--sticked": "_4w2Gda_navigation--sticked",
});
